export var SpinnerSize = /*#__PURE__*/ function(SpinnerSize) {
    SpinnerSize["xs"] = "xs";
    SpinnerSize["s"] = "s";
    SpinnerSize["m"] = "m";
    SpinnerSize["l"] = "l";
    SpinnerSize["xl"] = "xl";
    return SpinnerSize;
}({});
